import chroma from 'chroma-js';
import * as u from './utils.js'

/*---------------------------------------------*/

const LEGACY_TEMPLATES = {
	simple2: {
		template: 'side_image',
		textPosition: 'bottom',
		ratingPosition2: 'below',
		imageEnabled: true,
		imageRadius: 'rounded',
		imageSizes: ['xs', 'xs', 's'],
	},

	bubbledown: {
		template: 'simple_bubble',
		textPosition: 'bottom',
		ratingPosition2: 'below',
		imageEnabled: true,
		imageRadius: 'square',
		imageSizes: ['xs','xs','s']
	},

	simplequote: {
		template: 'side_image',
		textPosition: 'bottom',
		ratingPosition2: 'above',
		imageEnabled: true,
		imageRadius: 'square',
		imageSizes: ['xs','xs','s']
	},

	simplequotenp: {
		template: 'quote',
		textPosition: 'top',
		ratingPosition2: 'below',
		imageEnabled: false,
		imageRadius: 'square'
	},

	bubbleup2: {
		template: 'simple_bubble',
		textPosition: 'top',
		ratingPosition2: 'above',
		imageEnabled: true,
		imageRadius: 'square',
		imageSizes: ['xs','xs','s']
	},

	circlelarge: {
		template: 'side_image_bubble',
		textPosition: 'bottom',
		ratingPosition2: 'below',
		imageEnabled: true,
		imageRadius: 'circle',
		imageSizes: ['xs','xs','s'],
		imageBorderWidth: 2
	},

	circlelargenb: {
		template: 'side_image',
		textPosition: 'bottom',
		ratingPosition2: 'below',
		imageEnabled: true,
		imageRadius: 'circle',
		imageSizes: ['xs','s','m'],
		imageBorderWidth: 2
	},

	triangleup: {
		template: 'simple_bubble',
		textPosition: 'top',
		ratingPosition2: 'below',
		imageEnabled: true,
		imageRadius: 'square',
		imageSizes: ['xs','xs','s']
	},

	bubbleup3: {
		template: 'simple_bubble',
		textPosition: 'top',
		ratingPosition2: 'below',
		imageEnabled: true,
		imageRadius: 'square',
		imageSizes: ['xs','s','s'],
		bubbleBorderWidth: 2
	},

	bubbleupnp: {
		template: 'default_bubble',
		textPosition: 'top',
		ratingPosition: 'above',
		imageEnabled: false,
		bubbleBorderWidth: 2
	},

	largequote: {
		template: 'side_image',
		textPosition: 'bottom',
		ratingPosition2: 'below',
		imageEnabled: true,
		imageRadius: 'square',
		imageSizes: ['xs','s','m']
	},

	bubbleright: {
		template: 'side_image_bubble',
		textPosition: 'bottom',
		ratingPosition2: 'below',
		imageEnabled: true,
		imageRadius: 'rounded',
		imageSizes: ['s','s','s'],
		bubbleBorderWidth: 1
	}
}

const MIN_TEMPLATE_WIDTH = {
	simple: 220,
	simple_bubble: 280,
	default: 220,
	default_bubble: 280,
	side_image: 276,
	side_image_bubble: 298,
	quote: 220,
}

/*---------------------------------------------*/

export default class MigrationMgr {
	static import(settings,itemsCount,contextMgr) {
		contextMgr.set('title.enabled',false);
		contextMgr.set('text.truncateLines',5);
		contextMgr.set('layout.spacing',8);
		contextMgr.set('layout.padding.leftright',8);
		contextMgr.set('layout.padding.topbottom',8);
		contextMgr.set('order',settings.order);
		
		
		// COLORS
		let bg1 = settings.bg1;
		let bg2 = settings.bg2;
		let color1 = settings.color1;
		let color2 = settings.color2;
		let detailsColor = (settings.design==='bubbleright') ? color1 : color2;
		
		contextMgr.set('style.bg.section',bg1);
		contextMgr.set('style.bg.box',bg2);
		
		contextMgr.set('style.text.color',color1);
		contextMgr.set('style.name.color', detailsColor);
		contextMgr.set('style.rating.color',detailsColor);
		contextMgr.set('style.job_title.color',detailsColor);
		contextMgr.set('style.date.color',detailsColor);

		contextMgr.set('style.icon.customColor',true);
		contextMgr.set('style.icon.color',detailsColor);
	
		contextMgr.set('style.form.button.text',window.U.getSafe(settings,'collect.button.color',bg2));
		contextMgr.set('style.form.button.bg',window.U.getSafe(settings,'collect.button.bg',color1));

		// if the background is transparent we better use solid #666 to make sure the controls are visible
		let hasBackground = bg1.color && chroma(u.renderColor(bg1)).alpha();
		let controlsColor = hasBackground ? color2 : '#666';
		contextMgr.set('layout.slider.arrows.color',controlsColor);
		contextMgr.set('layout.slider.paging.dots.color',controlsColor);


		// TEMPLATE
		contextMgr.set('fields.rating.enabled',true);
		contextMgr.set('style.testimonial.border.width',0);
		contextMgr.set('fields.icons.enabled',true);

		// TODO: set the alignment only for the selected template
		contextMgr.set('template.alignment','left');
		contextMgr.set('template.simple.alignment','left');
		contextMgr.set('template.default.alignment','left');
		contextMgr.set('template.side_image.alignment','left');
		contextMgr.set('template.quote.alignment','left');

		let templateSettings = LEGACY_TEMPLATES[settings.design];
		contextMgr.set('template.id',templateSettings.template);
		contextMgr.set('template.textposition',templateSettings.textPosition);
		contextMgr.set('template.ratingposition',templateSettings.ratingPosition);
		contextMgr.set('template.ratingposition2',templateSettings.ratingPosition2);
		contextMgr.set('fields.image.enabled',templateSettings.imageEnabled);
		contextMgr.set('style.image.radius',templateSettings.imageRadius);

		contextMgr.set('style.image.border.color',bg2);
		contextMgr.set('style.image.border.width',templateSettings.imageBorderWidth || 0);

		let hasBubble = (templateSettings.template.indexOf('bubble') !== -1);
		let templatesWithoutBG = ['simplequote','circlelargenb','largequote'];
		let templateWithoutBG = templatesWithoutBG.indexOf(settings.design) !== -1;
		contextMgr.set('style.bg.testimonial', (hasBubble || templateWithoutBG) ? bg1 : bg2);

		if (templateSettings.bubbleBorderWidth) {
			contextMgr.set('style.bubble.border.width',templateSettings.bubbleBorderWidth);
			contextMgr.set('style.bubble.border.color','#c8c8c8');
		}

		let appWidth = document.body.clientWidth;
		let minTemplateWidth = MIN_TEMPLATE_WIDTH[templateSettings.template];
		let oldColumnWidth = appWidth / settings.cols;
		if (oldColumnWidth < minTemplateWidth) {
			let maxSupportedColumns = Math.max(Math.floor(appWidth / minTemplateWidth), 1);
			settings.cols = maxSupportedColumns;
		}

		if (templateSettings.imageEnabled) {
			let breakpoint = (oldColumnWidth < 300) ? 0 : (oldColumnWidth < 400 ? 1 : 2);
			let imageSize = templateSettings.imageSizes[breakpoint];
			contextMgr.set('style.image.size',imageSize);
		}

		// LAYOUT
		contextMgr.set('layout.navigation.type',''); // default

		let sliderEnabled = settings.slider && (settings.slider.pager || settings.slider.arrows || settings.slider.autoplay);
		if (sliderEnabled && 1*settings.rows === 1) {
			const DEFAULT_MAX_SLIDE_LIMIT = 9;
			let slidesCount = Math.ceil(itemsCount / settings.cols);
			if (slidesCount > DEFAULT_MAX_SLIDE_LIMIT)
				contextMgr.set('layout.slider.maxSlidesLimit',slidesCount);

			contextMgr.set('layout.type','slider');
			contextMgr.set('layout.slider.maxSlides',Math.max(DEFAULT_MAX_SLIDE_LIMIT,slidesCount));
			contextMgr.set('layout.cols',settings.cols);
			contextMgr.set('layout.slider.paging.enabled',settings.slider.pager);
			contextMgr.set('layout.slider.arrows.enabled',false);
			contextMgr.set('layout.slider.transition',(settings.slider.transition === 'fade') ? 'crossfade' : 'scroll');

			if (settings.slider.autoplay) {
				contextMgr.set('layout.slider.autoplay.enabled',true);
				contextMgr.set('layout.slider.autoplay.speed',settings.slider.pause);
			}

		} else {
			if (settings.cols === 1) {
				contextMgr.set('layout.type','list');
				
			} else {
				contextMgr.set('layout.type','grid');
				contextMgr.set('layout.cols',settings.cols);
			}
	
			if (1*settings.rows > 0) {
				// only ROWSxCOLS number of testimonials is displayed
				contextMgr.set('layout.rows',1*settings.rows);

				if (sliderEnabled) {
					contextMgr.set('layout.navigation.type','pages');

				} else {
					contextMgr.set('layout.navigation.type','');
					contextMgr.set('content.limit.enabled',true);
					contextMgr.set('content.limit.count',1*settings.rows*settings.cols);
					// need to use the original number of cols, before updating based on width
				}
			}
		}

		
		// FORM
		if (settings.collect && settings.collect.enabled) {
			contextMgr.set('form.enabled',true);
			contextMgr.set('form.button.text',window.U.getSafe(settings,'collect.buttonTitle','Submit Testimonial'));
			contextMgr.set('form.button.valignment',window.U.getSafe(settings,'collect.button.pos','bottom'));
			
			contextMgr.set('form.title.text',window.U.getSafe(settings,'collect.labels.title','Add Your Testimonial'));
			
			contextMgr.set('form.fields.author_name.label',window.U.getSafe(settings,'collect.labels.name','Name'));
			contextMgr.set('form.fields.text.label',window.U.getSafe(settings,'collect.labels.text','Your Testimonial'));
			contextMgr.set('form.fields.author_email.label',window.U.getSafe(settings,'collect.labels.email','Email (will be hidden)'));

			contextMgr.set('form.fields.company.enabled',false);
			contextMgr.set('form.fields.job_title.enabled',false);
			contextMgr.set('form.fields.rating.enabled',false);
		}
	}
}
